import type { Attachment } from "../api/types";
import { formatBytes } from "../lib/format";
import type { UploadItem } from "../lib/useUploads";
import { Icon } from "./Icon";

export function AttachmentList({ attachments }: { attachments: Attachment[] }) {
  if (!attachments.length) return null;
  const images = attachments.filter((a) => a.is_image);
  const files = attachments.filter((a) => !a.is_image);
  return (
    <div className="attachments">
      {images.length > 0 && (
        <div className="attachment-images">
          {images.map((a) => (
            <a key={a.id} href={a.url} target="_blank" rel="noopener noreferrer" title={a.filename}>
              <img src={a.url} alt={a.filename} loading="lazy" />
            </a>
          ))}
        </div>
      )}
      {files.length > 0 && (
        <div className="attachment-chips">
          {files.map((a) => (
            <AttachmentChip key={a.id} a={a} />
          ))}
        </div>
      )}
    </div>
  );
}

export function AttachmentChip({ a }: { a: Attachment }) {
  const href = a.url.includes("?") ? `${a.url}&download=1` : `${a.url}?download=1`;
  return (
    <a className="chip" href={href} title={`${a.filename} (${a.content_type})`}>
      <Icon name="file" size={14} />
      <span className="chip-name">{a.filename}</span>
      <span className="chip-meta">{formatBytes(a.size)}</span>
    </a>
  );
}

export function UploadList({
  items,
  onRemove,
}: {
  items: UploadItem[];
  onRemove: (key: string) => void;
}) {
  if (!items.length) return null;
  return (
    <div className="upload-list">
      {items.map((i) => (
        <div key={i.key} className={`upload-item ${i.error ? "upload-error" : ""}`}>
          {i.preview ? (
            <img src={i.preview} alt="" className="upload-thumb" />
          ) : (
            <span className="upload-thumb upload-thumb-file">
              <Icon name="file" />
            </span>
          )}
          <div className="upload-info">
            <span className="upload-name" title={i.file.name}>
              {i.file.name}
            </span>
            {i.error ? (
              <span className="upload-status error-text">{i.error}</span>
            ) : i.attachment ? (
              <span className="upload-status muted">{formatBytes(i.file.size)}</span>
            ) : (
              <span className="progress">
                <span style={{ width: `${Math.round(i.progress * 100)}%` }} />
              </span>
            )}
          </div>
          <button
            type="button"
            className="btn-icon"
            onClick={() => onRemove(i.key)}
            aria-label={`Remove ${i.file.name}`}
          >
            <Icon name="x" size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
